// extracted by mini-css-extract-plugin
export default {"quantity_wrapper":"fY","increment":"gY","decrement":"hY","product":"iY","product_info":"jY","text":"kY","modify_btn":"lY","controls":"mY","price":"nY","deliveredOnce":"oY"};
    if(module.hot) {
      // 1714654898377
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  